import * as React from 'react';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { CardMedia, Grid2 } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import { CustomIconButton } from '../../utils/IconButton';
import CardContainer from '../../utils/CardContainer';
import ProgressBar from '../student/ProgressBar';
import MainDialogBox from '../Dialog/MainDialogBox';
import { useDialog } from '../../hook/useDialog';
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import MenuPopover from '../Menu/MenuPopover';
import { useMenu } from '../../hook/useMenu';
import { FileUploadFormField } from '../formfields/FileUploadFormField';
// import api from '../../../assets/api/useStudentPostApi';
import { useMutation } from '@tanstack/react-query';
import useAuthStore from '../../../store/useAuthStore';
import { useToaster } from '../../utils/ToasterProvider';
import { ImagePath, ImageRelativePath } from '../../constants';
import { useNavigate } from 'react-router-dom';
import { useOnlineMeetingDetail } from '../../../assets/api/UseStudentGetApi';
import MeetingCard from '../student/MeetingCard';
import { getCourseStatusColor } from '../student/CurrentClassCard';
import api from '../../../assets/nodeApi/axiosInstance';

const CurrentClassCard = ({ item }) => {
    const {
        event_name,
        apartment_name,
        cover_image,
        start_date,
        course_id,
        apartments_id,
        batch_id,
        course_status,
        facility_name,
        batch_name,
        end_date,
        type,
        slug
    } = item

    const { token, user } = useAuthStore();
    const { open: openUpload, handleClickOpen: handleClickOpenUpload, handleClose: handleCloseUpload } = useDialog();
    const { anchorEl, openMenu, handleMenuOpen, handleMenuClose } = useMenu();
    const { showToaster } = useToaster();
    const { open: openschedule, handleClickOpen: handleScheduleOpen, handleClose: handleScheduleClose } = useDialog();
    const { data: MeetingDetail } = useOnlineMeetingDetail({ batch_name: batch_name })
    const navigate = useNavigate();

    const menuItems = React.useMemo(() => {
        if (type === 6 && (course_status === "Ongoing Class" || course_status === "Upcoming Class")) {
            return [
                {
                    label: "View Schedules",
                    onClick: () => {
                        handleMenuClose();
                        handleScheduleOpen();
                    },
                },
            ];
        }
        return [
            {
                label: "Assessment Credit",
                onClick: () => {
                    handleMenuClose();
                    showToaster(
                        'We Are Working On this Functionality',
                        'Currently Unavailable',
                        'warning'
                    );
                },
            },
        ];
    }, [type, handleClickOpenUpload, handleMenuClose, handleScheduleOpen, showToaster]);

    const createMemoryMutation = useMutation({
        mutationFn: (formData) => api.post("student-memories/create", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }),
    });
    const handleSubmitFileUpload = (values, { resetForm }) => {
        const formData = new FormData();
        formData.append('memories_images', values.image);
        formData.append('course_id', course_id);
        formData.append('trainer_id', user?.id);
        formData.append('created_by', user?.id);
        formData.append('updated_by', user?.id);
        formData.append('apartment_id', apartments_id);
        formData.append('batch_id', batch_id);
        createMemoryMutation.mutate(formData, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster(response?.data?.message, '', 'success')
                    handleCloseUpload();
                    resetForm();
                } else {
                    showToaster('Something went wrong!', '', 'error')
                }
            },
            onError: (error) => {
                showToaster(error?.data?.error, '', 'error')
            }
        });
    };


    const details = [
        { label: "Batch", value: batch_name },
        ...(type !== 6
            ? [
                { label: "Facility", value: facility_name },
                { label: "Apartment Name", value: apartment_name },
            ]
            : []),
    ];

    const additionalDetails = [
        { label: "Status", value: course_status },

    ];

    return (
        <>
            <CardContainer>
                <CardMedia
                    sx={{
                        width: { lg: "35%", xs: "100%" },
                        borderRadius: "15px",
                        height: { lg: "auto", xs: "200px" }
                    }}
                    image={`${ImagePath}${ImageRelativePath}${cover_image}`}

                />
                <CardContent sx={{ flex: 1, px: { lg: "15px", xs: "0" } }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                        <Box>
                            <Typography variant='h5'>{event_name}</Typography>
                            <Typography variant='h6' color='secondary.light'>{start_date} - {end_date}</Typography>
                        </Box>
                        <CustomIconButton icon={<Icon icon="ph:dots-three-outline-vertical-fill" color='#D9D9D9' height="30" />} onClick={handleMenuOpen} />

                    </Box>
                    {[details, additionalDetails].map((group, index) => (
                        <Box key={index}>
                            {group.map(({ label, value }, idx) => (
                                <Typography key={idx} fontSize={"13px"} variant="body2">
                                    {label} : {" "}
                                    {value ? (
                                        label === "Status" ? (
                                            <>
                                                <Typography
                                                    component="span"
                                                    fontSize={"13px"}
                                                    sx={{ color: getCourseStatusColor(course_status) }}
                                                >
                                                    {value}
                                                </Typography>

                                            </>

                                        ) : (
                                            value
                                        )
                                    ) : (
                                        ""
                                    )}
                                </Typography>
                            ))}

                        </Box>

                    ))}

                    <Box my={2}> <ProgressBar /></Box>



                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button variant='contained' fullWidth

                            onClick={() => { type === 6 ? navigate(`/trainer/onlinecoursedetail/${slug}/${batch_id}`) :type === 9? navigate(`/trainer/summercampcoursedetail/${slug}/${apartments_id}/${course_id}`):navigate(`/trainer/coursedetail/${slug}/${apartments_id}/${course_id}`) }}

                        >
                            View Detail
                        </Button>
                    </Box>

                </CardContent>
            </CardContainer>

            <MainDialogBox open={openUpload} handleClose={handleCloseUpload} heading={"Classroom Attendance Verification: Photo Submission"} width={"40%"}>
                <Formik initialValues={{ image: "" }} validationSchema={yup.object().shape({
                    image: yup.string().required("Please Upload File")
                })} onSubmit={handleSubmitFileUpload}>
                    {() => (
                        <Form >
                            <Grid2 container spacing={3} >
                                <Grid2 children size={{ xs: 12 }}>
                                    <Field
                                        name="image"
                                        component={FileUploadFormField}
                                        label="Upload Profile Picture"
                                    />

                                </Grid2>
                                <Grid2 children size={{ xs: 12 }}>
                                    <Button variant='contained' fullWidth type="submit" >  {createMemoryMutation.isLoading ? "Uploading..." : "Upload"}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>

            <MainDialogBox open={openschedule} handleClose={handleScheduleClose} width={"60%"}>
                {
                    !MeetingDetail?.status && <Typography>Schedule is not Created  yet</Typography>
                }
                {
                    MeetingDetail?.status && <>

                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box>
                                <Typography variant='h5' mb={1}>{event_name}</Typography>
                                <Typography variant='body2'>Online Class</Typography>
                            </Box>

                            <Box>
                                <Typography variant='body2' mb={1}>Course Start Date : {MeetingDetail?.start_date}</Typography>
                                <Typography variant='body2'>Course End Date : {MeetingDetail?.end_date}</Typography>
                            </Box>
                        </Box>
                        {
                            MeetingDetail?.data?.map((item, index) => (
                                <MeetingCard item={item} key={index} detail={MeetingDetail} />
                            ))
                        }
                    </>
                }

            </MainDialogBox>
            <MenuPopover
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                menuItems={menuItems}
            />
        </>
    )
}

export default CurrentClassCard